import { render, staticRenderFns } from "./TableList1.vue?vue&type=template&id=ecb084a6&scoped=true"
import script from "./TableList1.vue?vue&type=script&lang=js"
export * from "./TableList1.vue?vue&type=script&lang=js"
import style0 from "./TableList1.vue?vue&type=style&index=0&id=ecb084a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb084a6",
  null
  
)

export default component.exports